module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cd-Db-Ef-Fb-Gc.285d285a.png";